import { PubSub, Subscriptions } from "Subscriptions";
import Guid from "Utils/Guid";

class OpenedOverlayer {
    id: string;
    target: string;

    constructor(id: string, target: string) {
        this.id = id;
        this.target = target;
    }
}

class Overlayer {

    overlayToken: string;
    openedOverlays: OpenedOverlayer[];

    constructor() {
        this.overlayToken = PubSub.subscribe(Subscriptions.Overlay.All, this.handleOverlay);
        this.openedOverlays = [];
    }

    WPStargetted = (params: {
        target: string;
        color: string;
        showLoader: boolean;
        show: boolean;
        showAsFixed: boolean
    }) => {
        PubSub.publish(Subscriptions.Overlay.Targetted, params);
    }

    targetted = (params: {
        target: string;
        color?: string;
        showLoader: boolean;
        show: boolean
    }) => {
        PubSub.publish(Subscriptions.Overlay.Targetted, params);
    }

    handleOverlay = (msg: string, params: any) => {
        let shouldShow: boolean;
        let target: string;
        let cssClass: string = '';
        let showLoader: boolean = false;
        let showAsFixed: boolean = false;

        if (typeof params === 'object' && params !== null) {
            shouldShow = params.show;

            if (params.additionalCssClass) {
                cssClass = params.additionalCssClass;
            }
        }
        else if (typeof params === 'boolean' &&
            (msg === Subscriptions.Overlay.App || msg === Subscriptions.Overlay.Search)) {
            shouldShow = params;
        } else {
            throw new Error("Can't parse the params sent to overlayer");
        }

        if (msg === Subscriptions.Overlay.Search) {
            target = '.branding-background';
            cssClass = 'overlay-search overlay-black ' + cssClass;
        } else if (msg === Subscriptions.Overlay.App) {
            target = 'body';
            cssClass = 'overlay-overall overlay-black ' + cssClass;
            showLoader = true;
        } else if (msg === Subscriptions.Overlay.Targetted) {
            if (typeof params.target === 'undefined') {
                throw new Error("You can't call a targeted overlay without providing a target");
            }

            target = params.target;

            if (typeof params.color === 'undefined' || params.color.toLowerCase() == 'black') {
                cssClass = 'overlay-black ' + cssClass;
            } else if (params.color.toLowerCase() === 'white') {
                cssClass = 'overlay-white ' + cssClass;
            } else if (params.color.toLowerCase() === 'white-workflow-readonly') {
                cssClass = 'overlay-readonly ' + cssClass;
            }

            if (typeof params.showLoader !== 'undefined') {
                showLoader = params.showLoader;
            }

            if (typeof params.showAsFixed !== 'undefined') {
                showAsFixed = params.showAsFixed;
            }
        }

        if (typeof target !== 'undefined' && target !== null) {
            const openedOverlayIdx = this.openedOverlays.findIndex(x => x.target === target);
            if (openedOverlayIdx > -1) {
                if (!shouldShow) {
                    $(target).removeClass('show-overlay');
                    this.closeOverlay(openedOverlayIdx);
                }
            }
            else {
                if (shouldShow) {
                    // Show the overlayer
                    this.openOverlay(msg, target, cssClass, showLoader, showAsFixed);
                }
            }
        }
    }

    private openOverlay(overlayType: string, target: string, cssClass: string, showLoader: boolean, showAsFixed: boolean) {
        const id: string = 'overlayer-' + Guid.createGuid();
        this.openedOverlays.push(new OpenedOverlayer(id, target));

        const template = $('<div class="overlay"></div>');
        template.attr('id', id);
        template.addClass(cssClass);
        template.hide();

        if (overlayType === Subscriptions.Overlay.Targetted && !showAsFixed) {
            template.addClass('overlay-targetted');

            // NOTE: This may cause some issues if we use another type of position
            // and put an overlay over it. However, this is required to get the
            // targetted overlay to work correctly.
            $(target).css('position', 'relative');
        } else {
            template.addClass('overlay-fixed');
        }

        if (showLoader) {
            template.append($('<div class="spinner"><div></div><div></div><div></div><div></div></div>'));
            $(target).addClass('show-overlay');
        }

        $(target).prepend(template);
        template.fadeIn();
    }

    private closeOverlay(idx: number) {
        $('#' + this.openedOverlays[idx].id).fadeOut(400, function () {
            $(this).remove();
        });

        this.openedOverlays.splice(idx, 1);
    }

    dispose = () => {
        PubSub.unsubscribe(this.overlayToken);
    }
}

const overlayer = new Overlayer();
export default overlayer;
